import { render, staticRenderFns } from "./LoginDisclaimers.vue?vue&type=template&id=b8d6c002&scoped=true&"
import script from "./LoginDisclaimers.vue?vue&type=script&lang=ts&"
export * from "./LoginDisclaimers.vue?vue&type=script&lang=ts&"
import style0 from "./LoginDisclaimers.vue?vue&type=style&index=0&id=b8d6c002&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d6c002",
  null
  
)

export default component.exports